<div class="about-us-view">
    <div class="about-us-content">
        <div class="about-us-header-content">
            <h1 class="header-text">About Us</h1>
            <p class="header-description">
                Simplify shared expenses and take the stress out of money
                management with
                our cutting-edge app. Streamline your finances, split costs, and
                gain valuable
                insights to optimize your spending.
            </p>
        </div>
        <div class="about-main">
            <h3 class="services-header-text">Our Serives</h3>
            <div class="services-content">
                <div class="service-list">Customizable expense groups for any
                    situation.</div>
                <div class="service-list">Seamless member addition and expense
                    tracking.</div>
                <div class="service-list">Automatic calculation and settlement
                    of shared costs.</div>
                <div class="service-list">Detailed expense reporting for
                    enhanced financial visibility.</div>
            </div>
        </div>
        <ccdl-card>
            <div class="contact-us-view">
                <h3 class="contact-header-text">Contact Us</h3>
                <div class="contact-us-content">
                    <ccdl-input
                        [labelName]="'First name'"
                        controlId="firstName"
                        [control]="getControl('firstName')"></ccdl-input>
                    <ccdl-input
                        [labelName]="'Last name'"
                        controlId="lastName"
                        [control]="getControl('lastName')"></ccdl-input>
                    <ccdl-input
                        [labelName]="'Email Address'"
                        controlId="emailId"
                        [control]="getControl('emailAddress')"
                        [displayErrors]="true"></ccdl-input>
                    <ccdl-input
                        [labelName]="'How can we help you?'"
                        controlId="helpYouId"
                        [control]="getControl('helpTextField')"
                        [displayErrors]="true"></ccdl-input>
                    <ccdl-button [btnLabel]="'Submit'" [size]="'lg'"
                        [btnType]="'primary'"></ccdl-button>
                </div>
            </div>
        </ccdl-card>
    </div>
</div>
